<div class="container">
  <app-template [title]="'Scan Printing'" *ngIf="finalize">
    <div class="no">
      <img
        style="width: 150px; height: 150px; margin-left: 20px"
        src="assets/img/error2.png"
        alt=""
      />
      <button
        type="button"
        (click)="back()"
        class="button"
        mat-raised-button
        color="primary"
        style="width: 120px; margin-left: 20px; margin-bottom: 30px"
      >
        Select Result
      </button>
      Sorry something went wrong with the result
    </div>
  </app-template>
  <div [ngSwitch]="mode" *ngIf="!finalize">
    <div *ngSwitchCase="'form'">
      <app-template [title]="'Scan Printing'" style="padding-bottom: 400px">
        <!-- <div class="info">
                <div class="single">
                    <div>
                      <p>Reg No. : <b>{{record.bill_no}}</b></p>
                      <p>Sub Dept. : <b>{{record.sub_department_name}}</b></p>
                      <p>Service Name : <b>{{record.service_name}}</b></p>
                      <p>Dept. : <b>{{record.department_name}}</b></p>
                    </div>
                  </div>
                  <button [disabled]="stateForm.invalid" (click)="onSubmit(e)"  mat-raised-button color="primary">
                    {{ isSaveLoading? "Adding": "Add"}}
                </button>
            </div> -->
        <div class="search" style="padding-top: 30px">
          <span class="input">
            <mat-form-field>
              <mat-label>Name</mat-label>
              <input [(ngModel)]="name" matInput placeholder="" />
            </mat-form-field>
          </span>
          <span class="input">
            <mat-form-field>
              <mat-label>Mobile No.</mat-label>
              <input
                type="number"
                [(ngModel)]="phone"
                matInput
                placeholder=""
              />
            </mat-form-field>
          </span>
          <span class="input">
            <mat-form-field>
              <mat-label>Gender</mat-label>
              <mat-select [(ngModel)]="sex" matNativeControl>
                <mat-option value="Male">Male</mat-option>
                <mat-option value="Female">Female</mat-option>
              </mat-select>
            </mat-form-field>
          </span>
          <span class="input">
            <mat-form-field class="size">
              <mat-label>Start Date</mat-label>
              <input
                matInput
                [matDatepicker]="startdate"
                (dateChange)="startDateChange($event)"
              />
              <mat-datepicker-toggle
                matSuffix
                [for]="startdate"
              ></mat-datepicker-toggle>
              <mat-datepicker #startdate></mat-datepicker>
            </mat-form-field>
          </span>
          <span class="input">
            <mat-form-field class="size">
              <mat-label>End Date</mat-label>
              <input
                matInput
                [matDatepicker]="enddate"
                (dateChange)="endDateChange($event)"
              />
              <mat-datepicker-toggle
                matSuffix
                [for]="enddate"
              ></mat-datepicker-toggle>
              <mat-datepicker #enddate></mat-datepicker>
            </mat-form-field>
          </span>
          <!-- <span class="input">
                  <mat-form-field>
                      <mat-label>Investigation</mat-label>
                      <input [(ngModel)]="investigation" (ngModelChange)="itemChange($event)" matInput>
                      <div class="float" style="position: relative; width: 3px;">
                        <div class="ret" *ngIf="drVisible" >
                          <div class="list" (click)="setitem(item)" *ngFor="let item of filterddata">{{item.name}}</div>
                        </div>
                      </div>
                    </mat-form-field>
                </span> -->
          <div>
            <button
              (click)="getResult()"
              style="margin-left: 30px; margin-top: 45px"
              mat-raised-button
              color="primary"
            >
              Search
            </button>
          </div>
        </div>
        <div class="data" style="padding-bottom: 400px">
          <div *ngIf="isLoading" style="margin-top: 200px" class="spinner">
            <mat-spinner></mat-spinner>
          </div>
          <table *ngIf="!isLoading" style="width: 100%">
            <tr class="back">
              <th>
                <button
                  class="primary"
                  mat-raised-button
                  (click)="optionsForMerge()"
                  [disabled]="!bill_Id"
                >
                  Merge
                </button>
              </th>
              <th>Test Id</th>
              <th>Bill Id</th>
              <th>Date</th>
              <th>Service Name</th>
              <th>Department</th>
              <th>Patient Name</th>
              <th>Finalized?</th>
              <th>Online?</th>
              <th>Printed?</th>
              <th>
                <span style="font-size: 13px; font-weight: 400">
                  <mat-checkbox
                    style="margin: 20px"
                    color="danger"
                    [(ngModel)]="NotifyDefaultRefDoctor"
                    >Notify Dr.</mat-checkbox
                  >
                </span>
              </th>
            </tr>
            <tr class="td" *ngFor="let item of data" style="cursor: pointer">
              <td>
                <mat-checkbox
                  color="primary"
                  class="example-margin"
                  [value]="item.result_id"
                  (change)="onCheckboxChange($event, item.bill_id)"
                >
                </mat-checkbox>
              </td>
              <td>{{ item.sample_id }}</td>
              <td>{{ item.bill_id }}</td>
              <td>{{ item.result_date | date }}</td>
              <td>{{ item.service_name }}</td>
              <td>{{ item.department_name }}</td>
              <td>{{ item.patient_name }}</td>
              <td *ngIf="item.is_finalized == 'N'">{{ item.is_finalized }}</td>
              <td
                style="background-color: #4a7e4a; color: white"
                *ngIf="item.is_finalized != 'N'"
              >
                Finalized at -
                {{ item.finalized_date | date : "yyyy-MM-dd HH:mm a" }}
              </td>

              <td *ngIf="item.pushedOnlineStatus == null">
                {{ item.pushedOnlineStatus }}
              </td>
              <td
                style="background-color: #4a7e4a; color: white"
                *ngIf="item.pushedOnlineStatus != null"
              >
                {{ item.pushedOnlineStatus }}
              </td>

              <td *ngIf="item.service.printed === null">
                {{ item.service.printed }}
              </td>
              <td
                style="background-color: #4a7e4a; color: white"
                *ngIf="item.service.printed === 'Y'"
              >
                Printed at -
                {{
                  item.service.printed_timestamp | date : "yyyy-MM-dd HH:mm a"
                }}
              </td>
              <td>
                <div class="dropdown">
                  <button class="dropbtn" mat-raised-button>Actions</button>
                  <div class="dropdown-content">
                    <a class="dropdown-item" (click)="addRecord(item)"
                      >Select</a
                    >
                    <a class="dropdown-item" (click)="pushOnline(item)"
                      >Push Online</a
                    >
                  </div>
                </div>
              </td>
            </tr>
          </table>
          <app-pagination [currentPage]="currentPage" [totalSize]="totalSize" 
          [pageSize]="pageSize" (pageChanged)="onPageChanged($event)"></app-pagination>
        </div>
      </app-template>
    </div>
    <div class="wizwig" *ngSwitchCase="'wiz'">
      <app-template
        [title]="'Print Xray'"
        style="z-index: -3; padding-bottom: 500px"
      >
        <button mat-raised-button color="primary" (click)="print()" [disabled]="this.templates?.data?.outstanding_amount > 0">
          Print
        </button>
        <button
          (click)="back()"
          class="create"
          mat-raised-button
          color="primary"
        >
          Back
        </button>
        <span>
          <label>Show barcode</label>
          <input
            [(ngModel)]="isChecked"
            (change)="checkValue(isChecked ? 'true' : 'false')"
            style="margin: 0 20px; cursor: pointer"
            type="checkbox"
          />
        </span>
        <div class="space"></div>
        <div class="form">
          <!-- <div *ngIf="tempLoad" style="margin-top: 50px;" class="spinner">
                <mat-spinner></mat-spinner>
              </div> -->
          <div
            *ngIf="!tempLoad"
            class="result"
            id="print-section"
            style="width: 800px; margin: auto; position: relative"
          >
            <div
              class="detail"
              style="
                margin-top: 0px;
                z-index: 2;
                display: flex;
                flex-direction: row;
                justify-content: space-between;
                margin-bottom: 20px;
                padding: 0 20px;
              "
            >
              <div class="main" style="z-index: 2">
                <div class="head">
                  <b>Patient Name :</b> {{ templates.data?.patient_name }}
                </div>
                <div class="head">
                  <b>Gender :</b> {{ templates?.data?.sex }}
                </div>
                <!-- <div class="name">
                  <b>Referred Code :</b> {{ templates.data?.referred_code }}
                </div> -->
                <div class="head">
                  <!-- <b>DOB :</b> {{ patient?.date_of_birth | date }} -->
                  <b>Age :</b> {{ templates?.data?.age }}
                </div>
                <div class="head">
                  <b>Address :</b> {{ templates?.data?.address }}
                </div>
                <div class="head">
                  <b>Reg. No. :</b> {{ templates?.data?.reg_code }}
                </div>
              </div>
              <div class="main" style="z-index: 2">
                <div class="name">
                  <b>Reporting Date:</b> {{ record?.result_date | date }}
                  <span>{{ record?.result_time }}</span>
                  <!-- <span style="color: red">{{ record?.finalized_time }}</span> -->
                </div>
                <!-- <div class="name">
                  <b>Sample Time:</b> {{ record?.sample_collect_date | date }}
                  <span>{{
                    record?.sample_collect_date | date : "h:mm a"
                  }}</span>
                </div> -->
                <div class="name">
                  <b>Printed Time:</b> {{ today | date }}
                  <span>{{ time }}</span>
                </div>
              </div>
            </div>

            <div
              class="return"
              style="width: 800px; margin-bottom: 20px; z-index: 2"
              #name
            ></div>

            <div
              class="sign"
              style="
                display: flex;
                flex-direction: row;
                justify-content: space-between;
                z-index: 2;
              "
            >
              <div *ngIf="!templates?.data?.finalizer?.name"></div>
              <div
                style="
                  z-index: 2;
                  display: flex;
                  flex-direction: column;
                  justify-content: center;
                "
                *ngIf="templates.data.finalizer.name"
              >
                <img
                  style="width: 250px; height: 70px; margin-left: -70px"
                  *ngIf="templates.data.finalizer.signature"
                  [src]="templates.data.finalizer.signature"
                  alt=""
                />
                <div>...........................</div>
                <div>{{ templates.data?.finalizer?.name }}</div>
                <div>{{ templates.data?.finalizer?.designation }}</div>
                <div>{{ templates.data?.finalizer?.qualification }}</div>
              </div>
              <img
                *ngIf="isChecked"
                style="width: 170px; height: 170px"
                [src]="templates.data.barcode"
                alt=""
              />
              <div *ngIf="!templates?.data?.initator.name"></div>
              <div
                style="
                  z-index: 2;
                  display: flex;
                  flex-direction: column;
                  justify-content: center;
                "
                *ngIf="templates?.data?.initator.name"
              >
                <img
                  style="width: 250px; height: 70px; margin-left: -70px"
                  [src]="templates?.data?.initator.signature"
                  alt=""
                />
                <div>...........................</div>
                <div>{{ templates?.data?.initator?.name }}</div>
                <div>{{ templates?.data?.initator?.designation }}</div>
                <div>{{ templates?.data?.initator?.qualification }}</div>
              </div>
            </div>
          </div>

          <div style="height: 500px; width: 100%"></div>
        </div>
      </app-template>
    </div>

    <div class="wizwig" *ngSwitchCase="'merge'">
      <app-template
        [title]="'Print Merge Result'"
        style="z-index: -3; padding-bottom: 500px"
      >
        <button
          (click)="back()"
          class="create"
          mat-raised-button
          color="primary"
        >
          Back
        </button>

        <div class="search" style="padding-top: 20px">
          <span class="input">
            <mat-form-field>
              <mat-label>Push Online</mat-label>
              <mat-select
                [(ngModel)]="is_push_online"
                (selectionChange)="selectPushOnline($event)"
                matNativeControl
              >
                <mat-option value="0"> No </mat-option>
                <mat-option value="1"> Yes </mat-option>
              </mat-select>
            </mat-form-field>
          </span>
          <span class="input">
            <mat-form-field>
              <mat-label>Machine Data</mat-label>
              <mat-select
                [(ngModel)]="is_machine_data"
                (selectionChange)="selectMachineData($event)"
                matNativeControl
              >
                <mat-option value="0"> No </mat-option>
                <mat-option value="1"> Yes </mat-option>
              </mat-select>
            </mat-form-field>
          </span>
          <span class="input">
            <mat-form-field>
              <mat-label>Letterhead</mat-label>
              <mat-select
                [(ngModel)]="is_letterhead"
                (selectionChange)="selectLetterHead($event)"
                matNativeControl
              >
                <mat-option value="0"> No </mat-option>
                <mat-option value="1"> Yes </mat-option>
              </mat-select>
            </mat-form-field>
          </span>
          <span class="input">
            <mat-form-field>
              <mat-label>PDF</mat-label>
              <mat-select
                [(ngModel)]="is_pdf"
                (selectionChange)="selectPdf($event)"
                matNativeControl
              >
                <mat-option value="0"> No </mat-option>
                <mat-option value="1"> Yes </mat-option>
              </mat-select>
            </mat-form-field>
          </span>
        </div>
        <button
          (click)="mergePrintResults()"
          class="create"
          mat-raised-button
          color="primary"
        >
          Merge Print
        </button>

        <div *ngIf="tempMergeLoad">
          <!-- <button
            (click)="printMerge()"
            class="create"
            mat-raised-button
            color="primary"
          >
            Print
          </button> -->

          <button
            (click)="printEditorContent()"
            class="create"
            mat-raised-button
            color="primary"
          >
            Print
          </button>

          <angular-editor
            [config]="editorConfig"
            [placeholder]="'Enter text here...'"
            [(ngModel)]="content"
          ></angular-editor>
          <!-- <div
            class="result"
            id="print-merge-section"
            style="width: 900px; margin: auto; position: relative"
          >
            <div
              class="detail"
              style="
                margin-top: 0px;
                z-index: 2;
                display: flex;
                flex-direction: row;
                justify-content: space-between;
                margin-bottom: 20px;
                padding: 0 20px;
              "
            >
              <div
                class="return"
                style="width: 800px; margin-bottom: 20px; z-index: 2"
                #merge
              ></div>
            </div>
          </div> -->
        </div>
      </app-template>
    </div>
  </div>
</div>
